var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRepeat = function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.996 11.738a1.5 1.5 0 0 1 .04-2.02h-6.38c-.653 0-1.314.286-1.826.853-.517.57-.83 1.375-.83 2.242a1.5 1.5 0 0 1-3 0c0-1.57.563-3.103 1.605-4.255 1.047-1.157 2.5-1.84 4.051-1.84h6.584l-.103-.09a1.5 1.5 0 0 1 1.976-2.257l3 2.625a1.5 1.5 0 0 1 0 2.258l-3 2.625a1.5 1.5 0 0 1-2.117-.141Zm-3.742 1.774a1.5 1.5 0 0 1-.137 2.113h6.477c.653 0 1.314-.286 1.826-.852.517-.571.83-1.375.83-2.242a1.5 1.5 0 1 1 3 0c0 1.57-.563 3.103-1.605 4.255-1.046 1.157-2.5 1.839-4.051 1.839h-6.477a1.5 1.5 0 0 1-1.98 2.254l-3-2.625a1.5 1.5 0 0 1 0-2.258l3-2.625a1.5 1.5 0 0 1 2.117.141Z",
    fill: "#fff",
    "data-fill-active": "true",
    stroke: "transparent"
  })));
};
export default SvgRepeat;